import type { Assets } from '../core/assets.js';
import type { Profile } from '../ui/profile.js';
export function drawRecords(ctx: CanvasRenderingContext2D, assets: Assets, profile: Profile): void {
  const frame = assets.sprites.get('fx_69');
  if (!frame) return;
  const x = 64 - (frame.width >> 1),
    y = 64 - (frame.height >> 1),
    font = assets.fontMain;
  ctx.save();
  ctx.translate(x, y);
  ctx.fillStyle = '#ff9a63';
  ctx.fillRect(2, 2, 103, 78);
  ctx.drawImage(frame, 0, 0);
  ctx.fillRect(11, 58, 77, 18);
  const colors = ['#fffe00', '#ffde00', '#ffb400', '#ff0101'];
  for (let i = 0; i < 4; i++) {
    const row = 8 + 17 * i;
    ctx.fillStyle = colors[i]!;
    ctx.fillRect(4, row, 96, 13);
    const icon = assets.sprites.get(`fx_${i > 0 && !profile.unlocked[i - 1] ? 52 : 47 + i}`);
    if (icon) ctx.drawImage(icon, 7, row - 1);
    font.draw(ctx, `${profile.bestAccuracy[i]}%`, 65, row + 7 - (font.glyphH >> 1));
    if (profile.bestOpponentScore[i]! < 10)
      font.draw(ctx, `10-${profile.bestOpponentScore[i]}`, 26, row + 7 - (font.glyphH >> 1));
    const medal = assets.sprites.get('fx_71');
    if (profile.perfectMedals[i] && medal) ctx.drawImage(medal, 87, row - 1);
  }
  const legend = assets.sprites.get('fx_70');
  if (legend) ctx.drawImage(legend, 50, 8);
  ctx.restore();
}
